'use strict';

import $ from 'jquery';

/**
 * Toggle comparer icon
 *
 * @param {JQuery} $elem
 * @param {boolean=} forceIsSaved
 */
const toggleComparerItem = function ($elem, forceIsSaved) {

	const configToggleAction = mpro.config.comparer.toggle_action;
	const elem = $elem[0];
	const $icon = $elem.find('svg.icon');
	const $label = $elem.find(elem.dataset.comparerToggleLabel);
	const stateIsSaved = ['', 'true'].includes(elem.dataset.comparerToggleAdded);
	const data = $elem.data();

	// Clear the saved flag
	if ((forceIsSaved === false) || (stateIsSaved === true && forceIsSaved == null)) {

		elem.removeAttribute('data-comparer-toggle-added');

		// Remove the extra element class
		if (data.comparerToggleClass) {
			$elem.removeClass(data.comparerToggleClass);
		}

		// Toggle the icon
		if ($icon.length) {

			const $iconSymbol = $icon.find('use');

			// Icon symbol
			if ($iconSymbol.length) {
				$iconSymbol
					.attr('href', '#' + (elem.dataset.comparerRemoveIcon || configToggleAction.icon_default_class))
					.attr('xlink:href', '#' + (elem.dataset.comparerRemoveIcon || configToggleAction.icon_default_class));
			}
			// Icon full svg
			else {
				$icon.html(`<use xlink:href="#${(elem.dataset.comparerRemoveIcon || configToggleAction.icon_default_class)}" href="#${(elem.dataset.comparerRemoveIcon || configToggleAction.icon_default_class)}"></use>`);
			}
		}

		// Toggle the label text
		if ($label.length) {
			$label.text(mpro.langvar('button_add_to_comparer'));
		}
		// Toggle the element's title
		$elem.attr('title', mpro.langvar('button_add_to_comparer'));
	}
	// Add the saved flag
	else if ((forceIsSaved === true) || (stateIsSaved === false && forceIsSaved == null)) {

		elem.setAttribute('data-comparer-toggle-added', '');

		// Remove the extra element class
		if (data.comparerToggleClass) {
			$elem.addClass(data.comparerToggleClass);
		}

		// Toggle the icon
		if ($icon.length) {

			const $iconSymbol = $icon.find('use');

			// Icon symbol
			if ($iconSymbol.length) {
				$iconSymbol
					.attr('href', '#' + (elem.dataset.comparerRemoveIcon || configToggleAction.icon_saved_class))
					.attr('xlink:href', '#' + (elem.dataset.comparerRemoveIcon || configToggleAction.icon_saved_class));
			}
			// Icon full svg
			else {
				$icon.html(`<use xlink:href="#${(elem.dataset.comparerRemoveIcon || configToggleAction.icon_saved_class)}" href="#${(elem.dataset.comparerRemoveIcon || configToggleAction.icon_saved_class)}"></use>`);
			}
		}

		// Toggle the label text
		if ($label.length) {
			$label.text(mpro.langvar('button_remove_from_comparer'));
		}
		// Toggle the element's title
		$elem.attr('title', mpro.langvar('button_remove_from_comparer'));
	}
};

/**
 * Handle add/delete comparer events
 *
 * @param {'add'|'delete'} actionType
 * @param {HTMLElement} triggerElement
 */
const comparerHandler = async function (actionType, triggerElement) {

	const $trigger = $(triggerElement);
	const $button = $trigger;
	const elemData = $trigger.data() || {};
	const product_id = String(triggerElement.dataset.comparerToggle || triggerElement.dataset.comparerDelete || '');
	const sendData = [{ product_id }];
	const extraOptions = elemData;

	// sendData must be array
	if (!product_id) {
		mpro.toast('error', 'Missing or invalid data');
		return;
	}

	// Comparer api
	const comparer = mpro.shop.comparer;
	// Get override success/error actions from extra options
	const overrideActions = comparer.getOverrideActions(extraOptions);

	try {
		// Disabled the button
		mpro.addButtonDisabled($button);
		// Execute the remote action
		const res = await comparer[actionType]({ items: sendData });
		// Execute all defined success handlers for the current action
		comparer.runSuccessHandlers(actionType, res, triggerElement, overrideActions.success);

		// Toggle icon
		const $buttons = $(`[data-comparer-toggle="${$button.attr('data-comparer-toggle')}"]`);
		$buttons.each(function () {
			toggleComparerItem($(this), actionType === 'add' ? true : false);
		});
	}
	catch (err) {
		// Default error handler
		comparer.runErrorHandlers(actionType, err, triggerElement, overrideActions.error);
	}
	finally {
		mpro.removeButtonDisabled($button);
	}
};

// Add init function that is executed on every page/fragment render
mpro.addInitStatic(async $container => {

	// Do comparer lookup only if we have a logged-in customer
	if (mpro.config.comparer.count_items > 0) {

		// Find all comparer items on page and query for status
		const $containerItems = $container.filter('[data-comparer-toggle]').add($container.find('[data-comparer-toggle]'));

		if ($containerItems.length > 0) {
			const sendItems = $containerItems.map((_, item) => {
				const idsString = String(item.dataset.comparerToggle);
				const product_id = idsString;
				return [{ product_id }];
			}).get();

			// Do delayed lookup (allow other lookup callbacks to stack for a short duration)
			mpro.shop.comparer.lookupDelayed(sendItems, (resp) => {
				try {

					const items = resp.items;

					// Show saved comparer items
					if (items.length > 0) {
						for (const item of items) {
							const dataId = [item.product_id].filter(Boolean).join('');
							const $elem = $containerItems.filter(`[data-comparer-toggle="${dataId}"]`);

							if ($elem.length > 0) {
								$elem.each(function () {
									toggleComparerItem($(this), true);
								});
							}
						}
					}
				}
				catch (err) {
					console.log('Comparer lookup failed', err);
				}
			});
		}
	}
});

// Add init function that is executed only on first dom-ready (it should contain only document/body delegate handlers)
mpro.addInitDelegate($ => {

	const $B = mpro.get$B();

	// Handle click event for add and remove comparer buttons
	$B.on('click.comparerToggle', 'a[data-comparer-toggle],button[data-comparer-toggle],div[data-comparer-toggle],span[data-comparer-toggle]', function (e) {
		e.preventDefault();
		// Delete from comparer
		if (['', 'true'].includes(this.dataset.comparerToggleAdded)) {
			comparerHandler('delete', this);
		}
		// Default to add to comparer
		else {
			comparerHandler('add', this);
		}
	});

	$B.on('click.deleteCart', 'a[data-comparer-delete],button[data-comparer-delete]', function (e) {
		e.preventDefault();

		const relatedButtons = $('[data-comparer-toggle=' + this.dataset.comparerDelete + ']');

		if (relatedButtons.length) {
			relatedButtons.each(function(){
				comparerHandler('delete', this);
			})
		}
		else {
			comparerHandler('delete', this);
		}
	});
});
